import BaseSportScoring from './BaseSportScoring';

/**
 * TennisScoring handles both singles and doubles.
 * Pass isDoubles=true for doubles variant (uses tennis_doubles config).
 */
class TennisScoring extends BaseSportScoring {
  constructor(isDoubles = false) {
    super(isDoubles ? 'tennis_doubles' : 'tennis');
    this.isDoubles = isDoubles;
  }

  get label() { return this.isDoubles ? 'Tennis (Doubles)' : 'Tennis'; }
}

export default TennisScoring;
